import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { setLanguage } from "@/lib/i18n";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.language === "ar" ? "ar" : "en";

  const toggle = () => setLanguage(current === "ar" ? "en" : "ar");

  return (
    <button
      type="button"
      onClick={toggle}
      className="inline-flex h-10 items-center gap-1.5 rounded-full border border-border bg-card px-3 text-sm font-medium text-foreground transition-colors hover:bg-muted"
      aria-label={t("header.language")}
    >
      <Globe className="h-4 w-4" />
      <span>{current === "ar" ? "EN" : "عربي"}</span>
    </button>
  );
}
